"use client"
import toast from 'react-hot-toast';
import React, { useEffect } from 'react'
import { FaArrowCircleRight } from "react-icons/fa";

import { Remove, AddCircle } from '@mui/icons-material';
import { Box, Grid, Card, Button, useTheme, Typography, IconButton } from '@mui/material';

import WinnersCarrosel from '../carrosel/winners-carrosel';

export default function InputNumbersThirty({
    value,
    onChange,
    options,
    minValue,
    maxValue,
    allowManualInput = false,
    raffle,
    setShowModalGateway,
    generalWinners
}) {
    const [tempValue, setTempValue] = React.useState(value);
    const theme = useTheme();
    const handleChange = (newValue) => {
        if (minValue != 0 && (value + newValue) < minValue) {
            // onChange(value)
            return;
        }
        if (maxValue != 0 && (value + newValue) > maxValue) {
            onChange(maxValue)
            return;
        }
        onChange(value + newValue)
    }

    const handleManualInput = (e) => {
        setTempValue(parseInt(e.target.value, 10));
    }

    function validateManualInput() {
        if (Number.isNaN(tempValue)) {
            toast.error("Por favor, insira um valor válido");
            onChange(0);
            setTempValue(null);
            return;

        }
        if (minValue != 0 && tempValue < minValue) {
            toast.error("O valor mínimo é " + minValue);
            onChange(minValue);
            setTempValue(null);
            return;
        }
        if (maxValue != 0 && tempValue > maxValue) {
            toast.error("O valor máximo é " + maxValue);
            onChange(maxValue);
            setTempValue(null);
            return;
        }
        setTempValue(null);
        onChange(parseInt(tempValue, 10));
    }

    const formatNumber = new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL', minimumFractionDigits: 2,
        maximumFractionDigits: 3
    });


    useEffect(() => {
        if (!minValue == 0 || !value) {
            return;
        }

        onChange(minValue);
    }, [minValue]);

    return (
        <Box
            bgcolor="white"
            width="100%"

            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
            borderRadius={2}
            sx={{ backgroundColor: "#e4e4e4" }}
        >
            <Card sx={{ width: "98%", borderRadius: '16px', marginBottom: 1, padding: '2px 4px', fontSize: "0.8em !important", fontWeight: '400', textAlign: 'center' }}>
                Quanto mais títulos, mais chances de ganhar!
            </Card>
            <WinnersCarrosel generalWinners={generalWinners} />
            <Grid container width="100%">
                {options.map((item, index) => {
                    if (item.popular) {
                        return (<Grid item xs={options.length > 4 ? 4 : 6} key={index} style={{ padding: 1 }}>
                            <Box
                                className="tempButton-second button-container-second"
                                onClick={() => { handleChange(item.quantity); }}
                                sx={{
                                    cursor: 'pointer',
                                    borderRadius: 1,
                                    bgcolor: 'white',
                                    height: 90,
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    width: '100%',
                                    border: "2px solid rgb(25, 135, 84)",
                                    backgroundColor: "rgb(200, 250, 205)",
                                    color: "black",

                                }}
                                style={{
                                    marginTop: 0
                                }}
                            >
                                <Typography style={{ fontSize: '2em', lineHeight: '1.3', fontWeight: 600 }}>+{item.quantity}</Typography>
                                <Typography variant='caption' style={{ fontSize: '1em' }}>Selecionar</Typography>
                            </Box>
                        </Grid>);
                    }
                    return (
                        (
                            <Grid item xs={options.length > 4 ? 4 : 6} key={index} style={{ padding: 1 }}>
                                <Box
                                    className="input-background"
                                    onClick={() => { handleChange(item.quantity); }}
                                    sx={{
                                        cursor: 'pointer',
                                        borderRadius: 1,
                                        backgroundColor: "#000",
                                        color: "white",
                                        height: 90,
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        width: '100%'
                                    }}
                                >
                                    <Typography style={{ fontSize: '2em', lineHeight: '1.3', fontWeight: 600 }}>+{item.quantity}</Typography>
                                    <Typography variant='caption' style={{ fontSize: '1em' }}>Selecionar</Typography>
                                </Box>
                            </Grid>
                        )
                    );
                })}
            </Grid>

            <Grid container spacing={1} width="100%" style={{ marginTop: -4 }}>
                <Grid item xs={5} sm={6} sx={{ height: "77px" }}>
                    <Box
                        border={2}
                        borderColor="white"
                        width="100%"
                        height={"100%"}
                        // my={2}
                        display="flex"
                        justifyContent="space-between"
                        borderRadius={1}
                        sx={{
                            backgroundColor: "white",
                            height: "80%"
                        }}
                    >
                        <IconButton onClick={() => { handleChange(-1); }}>
                            <Remove />
                        </IconButton>
                        <Box display="flex" justifyContent="center" alignItems="center">
                            {
                                !allowManualInput ?
                                    <Typography variant='h5'>{value}</Typography>
                                    :
                                    <input
                                        value={tempValue ? tempValue : value}
                                        style={{
                                            fontSize: "1.25rem",
                                            margin: 0,
                                            padding: 0,
                                            fontWeight: 700,
                                            textAlign: "center",
                                            outline: "none",
                                            boxShadow: "none",
                                            backgroundColor: "transparent",
                                            width: "100%",
                                            height: "70%",
                                            border: "1px solid lightgray",
                                            borderRadius: 10
                                        }}
                                        onChange={handleManualInput}
                                        onBlur={validateManualInput}
                                    />
                            }
                        </Box>
                        <IconButton onClick={() => { handleChange(1); }}>
                            <AddCircle />
                        </IconButton>
                    </Box>
                </Grid>
                <Grid item xs={7} sm={6}>
                    <Button onClick={() => {
                        if (value < raffle.min_numbers) {
                            toast.error("O número mínimo de títulos deve ser " + String(raffle.min_numbers))
                            return;
                        }
                        if (value == 0) {
                            toast.error("Selecione ao menos uma cota!")
                            return;
                        }
                        setShowModalGateway(true)
                    }} sx={{ display: "flex", justifyContent: "space-between" }} fullWidth variant="contained" color="primary">
                        <div style={{ display: "flex", alignItems: "center" }}>
                            <FaArrowCircleRight style={{ fontSize: "2rem", marginRight: 10 }} />
                            <Box sx={{ display: "flex", flexDirection: "column" }}>
                                <Typography variant='body1' sx={{ fontWeight: 400, p: 0, m: 0, mb: .8, fontSize: '0.8rem', flexWrap: 'nowrap', textWrap: 'nowrap' }}>Quero participar</Typography>
                                <Typography fontWeight={100} sx={{ fontWeight: 700, textAlign: "start", p: 0, m: 0, mt: -0.5, fontSize: 15 }} variant='caption'>{formatNumber.format(value * raffle.numbers_price)}</Typography>
                            </Box>
                        </div>

                    </Button>
                </Grid>
            </Grid>
        </Box>
    )
}
